@if (appVersionLog.length > 0) {
  <vwui-tooltip class="version-tooltip" position="top-end">
    {{ 'COMPONENT.version' | translate:{version: appVersion} }}
    <div slot="label" class="version-tooltip__content">
      @for (entry of appVersionLog; track entry) {
        <div class="version-tooltip__entry">
          <small class="version-tooltip__date">{{ entry.date | date: ('DATE.short' | translate) }}</small>
          <div class="version-tooltip__subject">{{ entry.subject }}</div>
        </div>
      }
    </div>
  </vwui-tooltip>
} @else {
  {{ 'COMPONENT.version' | translate:{version: appVersion} }}
}
